import { render, staticRenderFns } from "./IndexClientPortfolios.vue?vue&type=template&id=37e2675e&scoped=true"
import script from "./IndexClientPortfolios.vue?vue&type=script&lang=js"
export * from "./IndexClientPortfolios.vue?vue&type=script&lang=js"
import style0 from "./IndexClientPortfolios.vue?vue&type=style&index=0&id=37e2675e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e2675e",
  null
  
)

export default component.exports